import { IApplicationState } from '../../types/redux';

export function selectFetchPhoneStatus(state: IApplicationState) {
  return state.phone.fetchPhoneStatus;
}
